import { UserGroupsActions } from '../types/UserGroupsActions';
import { UserGroupsBody } from '../types/UserGroupsBody';

interface UserGroupsState {
	list: UserGroupsBody[],
	count: number,
};

const initialState: UserGroupsState = {
	list: [],
	count: 0,
};


const userGroupsReducers = (state = initialState, action: UserGroupsActions) => {
	switch (action.type) {
		case 'USER_GROUPS_LIST_SUCCESS': {
			return { ...state, list: action.data }
		}
		case 'USER_GROUP_COUNT_SUCCESS': {
			return { ...state, count: action.data }
		}
		default:
			return state;
	}
}

export default userGroupsReducers;